import useTranslation from "@babackapp/translations/use-translation";
import { Badge } from "@babackapp/ui/components/badge";

export type StripeConfigurationStatus =
  | "all-good"
  | "warning"
  | "error"
  | "none";

type IntegrationConfigurationTagProps = {
  type: StripeConfigurationStatus;
};

export function IntegrationConfigurationTag({
  type,
}: IntegrationConfigurationTagProps) {
  const t = useTranslation();

  if (type === "warning") {
    return (
      <Badge className="self-start" variant="warning-outline">
        {t("settings.integrations.tags.configuration-warning")}
      </Badge>
    );
  }

  if (type === "error") {
    return (
      <Badge className="self-start" variant="destructive-outline">
        {t("settings.integrations.tags.configuration-error")}
      </Badge>
    );
  }

  return (
    <Badge className="self-start" variant="success-outline">
      {t("settings.integrations.tags.configuration-complete")}
    </Badge>
  );
}
